module.exports = __webpack_public_path__ + "static/media/arrow-next-orange.c44531d5.svg";